import { useMemo, useState } from "react";
import { CalendarRange, Lock } from "lucide-react";
import CrudTable from "../../components/CrudTable";
import { fmtDate } from "../../lib/format";
import { useAuth } from "../../context/AuthContext";

const thisYear = new Date().getFullYear();
const RECURRING_OPTS = [{ value: "true", label: "Evet — resmi bayram (her yıl aynı gün/ay)" }, { value: "false", label: "Hayır — yıl bazlı (dini bayram)" }];
// yıl seçenekleri: kayıtlı yıl bazlı tatillerin yılları + 2020–2030 aralığı
const yearOptions = (items) => [...new Set([...items.filter((h) => !h.recurring).map((h) => String(h.date).slice(0, 4)), ...Array.from({ length: 11 }, (_, i) => String(2020 + i)), String(thisYear)])].sort();

// Resmi tatiller: yıl filtresi (her yıl tekrar edenler her yılda görünür); ekleme/düzeltme/silme yalnız Yönetici ve İK
export default function Holidays({ standalone = false }) {
  const { user } = useAuth();
  const canEdit = user?.role === "admin" || user?.role === "ik";
  const [year, setYear] = useState(String(thisYear));
  const filterFn = useMemo(() => (it) => it.recurring || String(it.date).startsWith(year), [year]);
  const toolbar = (items) => (
    <div className="flex items-center gap-2 flex-wrap">
      <label className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-700"><CalendarRange className="w-3.5 h-3.5" /> Yıl
        <select value={year} onChange={(e) => setYear(e.target.value)} data-testid="holiday-year" className="px-2 py-1 text-xs border border-slate-300 rounded-md bg-white outline-none focus:border-slate-800">
          {yearOptions(items).map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </label>
      <span className="text-[11px] text-slate-500" data-testid="holiday-year-count">{items.filter((it) => it.recurring || String(it.date).startsWith(year)).length} tatil · her yıl tekrar edenler seçili yılın tarihiyle gösterilir</span>
      {!canEdit && <span className="inline-flex items-center gap-1 text-[11px] text-slate-500 bg-slate-50 border border-slate-200 rounded px-2 py-0.5" data-testid="holiday-readonly"><Lock className="w-3 h-3" /> Ekleme / düzeltme / silme yalnız Yönetici ve İK</span>}
    </div>
  );
  return (
    <div className="space-y-3">
      {standalone && <div><h1 className="text-3xl font-bold tracking-tight">Resmi Tatiller</h1><p className="text-sm text-slate-500 mt-1">Yıllık izin ve geçici personel gün hesabında düşülen resmi ve dini bayram günleri — dini bayramları her yıl tarihiyle girin.</p></div>}
      <CrudTable
        resource="holidays"
        title=""
        subtitle=""
        testidPrefix="holiday"
        readOnly={!canEdit}
        toolbar={toolbar}
        filterFn={filterFn}
        defaults={{ date: `${year}-01-01`, name: "", recurring: "false" }}
        columns={[
          { key: "date", label: "Tarih", render: (it) => fmtDate(it.recurring ? `${year}-${String(it.date).slice(5)}` : it.date) },
          { key: "name", label: "Tatil Adı" },
          { key: "recurring", label: "Her Yıl", render: (it) => (it.recurring ? <span className="px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-800 text-[10px] font-bold">HER YIL (gün/ay)</span> : <span className="text-slate-500 text-[11px]">yıl bazlı</span>) },
        ]}
        fields={[
          { key: "date", label: "Tarih", type: "date", validate: (v) => (!v ? "Tarih zorunludur" : "") },
          { key: "name", label: "Tatil Adı", type: "text", validate: (v) => (!String(v || "").trim() ? "Tatil adı zorunludur" : "") },
          { key: "recurring", label: "Her yıl aynı gün mü?", type: "select", options: RECURRING_OPTS },
        ]}
      />
    </div>
  );
}
